DOMReady( function(){
    if(document.querySelector('#calculer-grossesse'))
    {
      document.getElementById('calculer-grossesse').addEventListener('click',function(){
        fetch( '/calendrier-grossesse', {
          cache: "no-store",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            date_derniere_regle:document.getElementById('date_derniere_regle').value,
            date_conception:document.getElementById('date_conception').value
          }),
        }).then( (response) => {
          return response.json();
        }).then( (responsedata) => {
          document.querySelector('.result-calendar').innerHTML = responsedata.html;
          
          resolve();
        }).catch( () => {

        });
      });
    }

});